import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { timeService, valorReloj } from 'src/app/services/time.service';
import { UserService } from '../../../services/user.service';
declare var $: any;
declare function getClock(time, id): any;

@Component({
    selector: 'app-intermediario-header',
    templateUrl: './intermediario-header.component.html',
    styleUrls: ['./intermediario-header.component.scss'],
    providers: [timeService],
    standalone: false
})
export class IntermediarioHeaderComponent implements OnInit {
  public user;
  ultimaConexion: string = '';
  ip: string = '';
  menusBancoldex: any[] = [];
  //variables de fechaa y hora actual
  fechaActual: Observable<valorReloj>;
  hora: number;
  minutos: string;
  dia: string;
  fecha: string;
  ampm: string;
  segundos: string;

  constructor(
    private _userIntermediarioService: UserService,
    public router: Router,
    private time: timeService
  ) {}

  ngOnInit(): void {
    this.user = this._userIntermediarioService.getUser();
    this.ultimaConexion =
      this._userIntermediarioService.getUser().fechaUltimoAcceso;
    this.ip = this._userIntermediarioService.getUser().ip;
    this.menusBancoldex = this._userIntermediarioService.getUser().gruposMenu;
    this.fechaActual=this.time.getInfoReloj();
    this.fechaActual.subscribe(x => {
      this.hora = x.hora;
      this.minutos = x.minutos;
      this.dia = x.diadesemana;
      this.fecha = x.diaymes;
      this.ampm = x.ampm;
      this.segundos = x.segundo
    });
  }

  async cerrarSesion() {
    await this._userIntermediarioService.deleteUser();
    this.router.navigate(['/home']);
  }

  toggle() {
    $('.offcanvas-collapse').toggleClass('open');
    this.hideMenu();
  }

  hideMenu(){
    $('.collapse').collapse('hide');
  }

  hideMenuBar(){
    $('.offcanvas-collapse').removeClass('open')
  }
}
